import { render, staticRenderFns } from "./DisqualificationList.vue?vue&type=template&id=458ca6f1"
import script from "./DisqualificationList.vue?vue&type=script&lang=js"
export * from "./DisqualificationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports